import React from 'react'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import LgySelectField from 'app/components/util/lgy-select-field/LgySelectField'
import { LgySubsection } from 'app/components/util/lgy-section/LgySection'
import LgyFormSubmit from 'app/components/util/lgy-form-submit/LgyFormSubmit'
import { parseBooleanToYesNoDropdown } from 'app/utils/fieldUtils'
import { submitInitialQuestionsForm } from 'app/gears/appraiser/assignment/components/initial-questions/initial-questions-action'
import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'

const InitialQuestionsForm = (props) =>
  <form onSubmit={props.handleSubmit}>
    <LgySubsection>
      {(props.aappUsedAnswered === null) && <LgyAlertDialog type='warning' heading='AAPP Questions Required' text={`You are required to answer the Assisted Appraisal Processing Program (AAPP) questions before proceeding to the assignment.`} />}
      {props.submitSucceeded && <LgyAlertDialog type='success' heading='AAPP Questions Submitted' text='Your Assisted Appraisal Processing Program questions have been submitted.' />}
      <Field component={LgySelectField} label='Will the Assisted Appraisal Processing Program (AAPP) be used for this appraisal?' name='aappUsed' required disabled={areAappQuestionsDisabled(props.dispositionCode)} >
        <option value='Yes'>Yes</option>
        <option value='No'>No</option>
      </Field>
      {props.aappQuestionAnsweredYes && <Field component={LgySelectField} label='Assisted Appraisal Processing Program Type' name='appraiserType' required={!areAappQuestionsDisabled(props.dispositionCode)} disabled={areAappQuestionsDisabled(props.dispositionCode)}>
        <option value='APPRAISER_TRAINEE'>Appraiser Trainee</option>
        <option value='NON_VA_APPRAISER'>Non-VA Appraiser</option>
        <option value='VA_APPRAISER'>VA Appraiser</option>
      </Field>}
      <LgyFormSubmit pristine={props.pristine} submitting={props.submitting} submitFailed={props.submitFailed} submitSucceeded={props.submitSucceeded} error={props.error} reset={props.reset} disabled={areAappQuestionsDisabled(props.dispositionCode)} />
    </LgySubsection>
  </form >




const InitialQuestionsFormHOC = reduxForm({ form: 'initialQuestions' })(InitialQuestionsForm)

const selector = formValueSelector('initialQuestions')

function shouldDisplayAappType(aappUsedAnswerValue, appraisalTypeCode, appraisalStatus, saleRefinancePrice, bwnHomeValueEnterpriseSetting) {
  return aappUsedAnswerValue === 'Yes' || aappUsedAnswerValue === true
}

function areAappQuestionsDisabled(dispositionCode) {
  if (dispositionCode === null) {
    return true
  } else if (dispositionCode !== 'O' && dispositionCode !== 'P' && dispositionCode !== 'I') {
    return true
  } else {
    return false
  }
}


const mapStateToProps = state => {
  const props = {
    aappUsedAnswered: (state.appraiser && state.appraiser.assignments && state.appraiser.assignments.assignmentDetails) ? state.appraiser.assignments.assignmentDetails.aappUsed : null,
    aappQuestionAnsweredYes: shouldDisplayAappType(selector(state, 'aappUsed')),
    dispositionCode: (state.appraiser && state.appraiser.assignments && state.appraiser.assignments.assignmentDetails) ? state.appraiser.assignments.assignmentDetails.dispositionCode : null,
    initialValues: {
      id: state.currentUser.entities.find(e => e.name === 'AppraiserInspector').values.id,
      aappUsed: (state.appraiser && state.appraiser.assignments && state.appraiser.assignments.assignmentDetails) ? parseBooleanToYesNoDropdown(state.appraiser.assignments.assignmentDetails.aappUsed) : null,
      appraiserType: (state.appraiser && state.appraiser.assignments && state.appraiser.assignments.assignmentDetails) ? state.appraiser.assignments.assignmentDetails.appraiserType : null,
      lin: (state.appraiser && state.appraiser.assignments && state.appraiser.assignments.assignmentDetails) ? state.appraiser.assignments.assignmentDetails.lin : null,
      propertyAppraisalId: (state.appraiser && state.appraiser.assignments && state.appraiser.assignments.assignmentDetails) ? state.appraiser.assignments.assignmentDetails.id : null
    }
  }
  return props
}

const mapDispatchToProps = {
  onSubmit: submitInitialQuestionsForm
}

// Connect to redux
export default connect(mapStateToProps, mapDispatchToProps)(InitialQuestionsFormHOC)
